import { createApp } from 'vue';
import PdfOcrConverter from '@/Components/PdfOcrConverter.vue';
import '@styles/app.css';

createApp(PdfOcrConverter).mount('#pdf-ocr-converter');
